import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login-confirm',
  templateUrl: './login-confirm.component.html',
  styleUrls: ['./login-confirm.component.css'],
})
export class LoginConfirmComponent implements OnInit {
  queries: {
    application_name: string;
    redirect_uri: string;
  } = {
    application_name: '',
    redirect_uri: '',
  };
  constructor(activerou: ActivatedRoute) {
    this.queries = activerou.snapshot.queryParams as any;
  }

  ngOnInit(): void {}
  confirm() {
    location.href = this.queries.redirect_uri;
  }
  cancel() {
    window.close();
  }
}
